/**
 * A brand's colour chip — the ONE place a brand colour becomes a paint (WS-Z7).
 *
 * Four inline background objects across the two Brands surfaces were four separate
 * inline-style sites, all writing the same declaration. A brand's colour genuinely IS data —
 * it cannot be a static rule — so what the markup carries is the VALUE, as the custom
 * property `--brand-swatch`, and the paint that reads it is one rule in `branding.css`.
 */
import type { CSSProperties } from "react";

export function BrandSwatch({ color, testId }: { color: string; testId?: string }) {
  return (
    <span
      className="brands__swatch"
      style={{ "--brand-swatch": color } as CSSProperties}
      data-testid={testId}
      // The colour is identification, not information: the brand's NAME is beside it and
      // carries the meaning. A decorative chip must not be announced twice.
      aria-hidden="true"
    />
  );
}
